
<template>
	<c-dialog ref="dialog" title="选择发货地" width="900" @resolve="resolve">
		<c-table ref="table" height="400" :paging="false">
			<c-table-column
				type="selector"
				:multiple="!!multiple"
				:selected="row => row.data.checked"
			></c-table-column>
			
			<c-table-column
				label="联系人"
				name="delivery_name"
				width="100"
			></c-table-column>
			<c-table-column
				label="联系方式"
				name="delivery_mobile"
				width="150"
			></c-table-column>
			
			<c-table-column
				label="地址"
				name="delivery_address"
				width="300"
			>
				<template v-slot="{data}">
					{{data.delivery_province_name}} {{data.delivery_city_name}} {{data.delivery_address}}
				</template>
			</c-table-column>
			<c-table-column
				label="创建时间"
				name="create_date"
				width="140"
			></c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
	export default {
		props: {
			multiple: Boolean
		},
		
		methods: {
			open(product_id) {
				this.$refs.dialog.open();
				this.$refs.table.load({
					url: '/product/get_product_delivery_addresss',
					data: {
						product_id
					}
				});
			},
			
			resolve(stop) {
				var data = this.$refs.table.getRow('selected');
				if (!data.length) {
					stop();
					this.$message({
						text: '请选择发货地'
					});
					return;
				}
				this.$emit('resolve', Array.from(data, item => item.data));
			}
		}
	}
</script>